// Attach the paperwork to a stock transaction — the delivery note, or the waste
// transfer note. Uploaded straight away (POST /stock/documents) so the transaction
// can name it by id; served back by /stock/documents/{id}, not /documents, whose
// gates are about personnel.
import { useRef, useState } from "react";
import axios from "axios";
import { Box, Button, Chip, CircularProgress, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { API_BASE_URL } from "../../config";

export default function StockDocumentField({ category, label, value, onChange }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = (file) => {
    if (!file) return;
    const body = new FormData();
    body.append("file", file);
    body.append("category", category);
    setBusy(true);
    axios.post(`${API_BASE_URL}/stock/documents`, body)
      .then(res => onChange({ id: res.data.id, name: res.data.original_filename }))
      .catch(() => {})
      .finally(() => { setBusy(false); if (input.current) input.current.value = ""; });
  };

  return (
    <Box>
      <input ref={input} type="file" hidden accept="application/pdf,image/*"
             onChange={e => upload(e.target.files?.[0])} />
      {value ? (
        <Chip icon={<AttachFileIcon />} label={value.name || "Attached"}
              onDelete={() => onChange(null)} />
      ) : (
        <Button size="small" variant="outlined" disabled={busy}
                startIcon={busy ? <CircularProgress size={14} /> : <AttachFileIcon />}
                onClick={() => input.current?.click()}>
          {label}
        </Button>
      )}
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
        A scan or photo of it — PDF or image.
      </Typography>
    </Box>
  );
}
